import { render, staticRenderFns } from "./role.vue?vue&type=template&id=39b0032d&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&lang=css&"
import style1 from "./role.vue?vue&type=style&index=1&id=39b0032d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0032d",
  null
  
)

export default component.exports